module.exports = __webpack_public_path__ + "public/Icons/lightModeOn.svg?f077a37e";